function clampDate(date, { min = new Date(), max }) {
  let newTime = date;
  if (min && newTime < min) {
    newTime = min;
  }
  if (max && newTime > max) {
    newTime = max;
  }
  return newTime;
}

export default clampDate;
